import { Tooltip } from "@material-ui/core"
import { TooltipULStyles } from "./styles";

type SubscriptionPlanTooltipProps = {
    children: JSX.Element
}

export const SubscriptionPlanTooltip = ({ children }: SubscriptionPlanTooltipProps) => {

    const ULStyles = TooltipULStyles();

    return <Tooltip
        title={
            <ul className={ULStyles.root}>
                <li>Authory-Subscription-USD-Monthly =&gt; Monthly</li>
                <li>Authory-Subscription-USD-Yearly =&gt; Yearly</li>
                <li>Authory-Discounted-Subscription-USD-Monthly =&gt; Monthly-D</li>
                <li>Authory-Discounted-Subscription-USD-Yearly =&gt; Yearly-D</li>
                <li>Authory-Legacy-Plan-7-USD-Monthly =&gt; Monthly-L</li>
                <li>Authory-Legacy-Plan-7-USD-Yearly =&gt; Yearly-L</li>
                <li>Authory-Pro-Subscription-2023-USD-Yearly =&gt; 2023 Pro Yearly</li>
                <li>Authory-Pro-Subscription-2023-USD-Monthly =&gt; 2023 Pro Monthly</li>
                <li>Authory-Subscription-2023-USD-Yearly =&gt; 2023 Yearly</li>
                <li>Authory-Subscription-2023-USD-Monthly =&gt; 2023 Monthly</li>
            </ul>
        }
    >
        {children}
    </Tooltip>
}
